import FaqAnswerCard from './FaqAnswerCard';

export default FaqAnswerCard;
